import { render, staticRenderFns } from "./CommunicationRecipients.vue?vue&type=template&id=51cc3bb2"
import script from "./CommunicationRecipients.vue?vue&type=script&lang=ts"
export * from "./CommunicationRecipients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports